<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data: function () {
            return {}
        }
    }
</script>

<style>
    body, html {
        padding: 0;
        margin: 0;
        height: 100%;
    }

    body {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }

    #app {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue